<template>
  <custom-btn-icon
    :btn-text="generateMessage('requests.actions.workorder_report_short')"
    @click.stop="handleClick"
    color="success"
    icon="mdi-file-outline"
  />
</template>

<script>
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';
import { generateMessage } from '@/utils/i18n';
import { mapActions } from 'vuex';

export default {
  name: 'WorkorderReportBtnDialog',
  components: {
    CustomBtnIcon,
  },
  props: {
    entity_nav_full_id: {
      type: String,
      required: true,
    },
    isAssigned: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPaused: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPemHis: {
      type: Boolean,
      required: false,
      default: false,
    },
    propertyId: {
      type: Number,
      required: true,
    },
    qualification: {
      type: Number,
      required: false,
    },
    requestId: {
      type: Number,
      required: true,
    },
    request: {
      type: Object,
      required: false,
    },
    status: {
      type: String,
      required: true,
    },
    technician_internal_id: {
      type: Number,
      required: false,
    },
    symptom: {
      type: Number,
      required: false,
    },
  },
  methods: {
    generateMessage,
    ...mapActions('modal', ['showModal']),
    handleClick() {
      this.showModal({
        componentName: 'WorkorderReportDialog',
        componentProps: {
          entity_nav_full_id: this.entity_nav_full_id,
          isAssigned: this.isAssigned,
          isPaused: this.isPaused,
          isPemHis: this.isPemHis,
          propertyId: this.propertyId,
          qualification: this.qualification,
          requestId: this.requestId,
          request: this.request,
          status: this.status,
          symptom: this.symptom,
          technician_internal_id: this.technician_internal_id,
        },
        dialogProps: {
          width: '500px',
        },
      });
    },
  },
};
</script>
